import { Component, Input } from '@angular/core';

@Component({
  selector: 'map-static',
  templateUrl: 'map-static.html'
})

export class MapStaticComponent {

 @Input('geostring') geoToUse;
 @Input('geozoom') zoomToUse;
 @Input('mapheight') heightToUse;
 @Input('mapwidth') widthToUse;
 @Input('maptype') typeToUse;

  geo: string;
  zoom: number;
  mheight: number;
  mwidth: number;
  mtype: string;
  mapOptions: string;
  apiKey: string = 'AIzaSyCrnod97v4Xs8s67ka8bQCj3dRoSuuNkDU';

  constructor() {
    this.geo = '-33.540973,26.140475';
    this.zoom = 8;
    this.mheight = 700;
    this.mwidth = 800;
    this.mtype = 'hybrid';
    }
  
  ngAfterViewInit(){
    this.geo = this.geoToUse;
    this.zoom = this.zoomToUse;
    this.mheight = this.heightToUse;
    this.mwidth = this.widthToUse;
    this.mtype = this.typeToUse;
    
    this.mapOptions='center='+this.geo+'&zoom=8&size='+this.mwidth+'x'+this.mheight+'&maptype='+this.mtype+'&markers=color:green%7Clabel:B%7C'+this.geo+'&apikey='+this.apiKey;
    //console.log(this.mapOptions);
   }
}



// WEBPACK FOOTER //
// ./src/components/map-static/map-static.ts